module.exports = __webpack_public_path__ + "static/mobile_04@2x-0cd60e96540e66517670c056dd45b8d0.png";